import { useBucketContext } from "context/bucket";
import { SortProperty } from "context/bucket/types";
import { FC } from "react";
import style from "../style.module.scss";

type SortLabelProps = {
  text: string;
  propertyBinded: SortProperty;
};

export const SortLabel: FC<SortLabelProps> = (props) => {
  const { sortStatus, handleSortByProperty } = useBucketContext();
  const { text, propertyBinded } = props;

  const handleClick = () => {
    handleSortByProperty(propertyBinded);
  };

  return (
    <div
      className={`d-inline-flex align-items-center gap-2 ${style.header}`}
      onClick={handleClick}
    >
      <h6 className={style["header_label"]}>{text}</h6>
      <div>
        {sortStatus.property === propertyBinded && (
          <i
            className={`bi bi-caret-${
              sortStatus.order === "asc" ? "up" : "down"
            }-fill`}
          />
        )}
      </div>
    </div>
  );
};
